<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      Verifikasi Akhir Studi Mahasiswa
    </h1>
    <div class="w-full">
      <div class="flex flex-nowrap mb-4">
        <div class="flex-none mr-4 md:w-1/5">
          <label
            for="verification_date_sdate"
            class="text-sm form-label">Tanggal Verifikasi:</label>
          <flat-pickr
            id="verification_date_sdate"
            v-model="form.trn_date"
            class="py-3 px-6 mr-2 w-full rounded shadow focus-ring"
            placeholder="YYYY-MM-DD" />
        </div>
        <div class="flex-none mr-4">
          <label
            for="validation_doc_verified"
            class="text-sm form-label">Lembar Pengesahan:</label>
          <select
            id="validation_doc_verified"
            class="form-select py-2"
            v-model="form.validation_doc_verified">
            <option
              :value="null"
              default
              class="text-center">
              ALL
            </option>
            <option value="BLM-VERIF" class="text-center">
              BLM VERIF
            </option>
            <option value="VERIF" class="text-center">
              VERIF
            </option>
          </select>
        </div>
        <div class="flex-none mr-4">
          <label
            for="diploma_verified"
            class="text-sm form-label">Ijazah:</label>
          <select
            id="diploma_verified"
            class="form-select py-2"
            v-model="form.diploma_verified">
            <option
              :value="null"
              default
              class="text-center">
              ALL
            </option>
            <option value="BLM-VERIF" class="text-center">
              BLM VERIF
            </option>
            <option value="VERIF" class="text-center">
              VERIF
            </option>
          </select>
        </div>
        <div class="flex-1">
          <label class="text-sm form-label">Cari Nama / NIM: </label>
          <search-filter
            v-model="form.search"
            placeholder="Cari Nama atau NIM..."
            :show-dropdown="false"
            class="flex-shrink-0 max-w-md"
            @reset="reset" />
        </div>
      </div>
    </div>
    <div class="w-full">
      <div class="flex flex-nowrap mb-4">
        <div class="flex-none mr-4">
          <label
            for="approval_status"
            class="text-sm form-label">Persetujuan Pembayaran:</label>
          <select
            id="approval_status"
            v-model="form.approval_status"
            class="form-select">
            <option
              :value="null"
              default
              class="text-center">
              ALL
            </option>
            <option :value="999" class="text-center">
              N/A
            </option>
            <option
              v-for="option in approvalStatusOptions"
              :key="option.id"
              :value="option.id">
              {{ option.status }}
            </option>
          </select>
        </div>
        <div class="flex-none mr-4">
          <label
            for="payment_status"
            class="text-sm form-label">Status Pembayaran:</label>
          <select
            id="payment_status"
            v-model="form.payment_status"
            class="form-select">
            <option
              :value="null"
              default
              class="text-center">
              ALL
            </option>
            <option :value="999" class="text-center">
              N/A
            </option>
            <option
              v-for="option in paymentStatusOptions"
              :key="option.id"
              :value="option.id">
              {{ option.status }}
            </option>
          </select>
        </div>
        <div class="flex-none mr-4">
          <label
            for="graduation_year"
            class="text-sm form-label">Tahun Pembayaran:</label>
          <select
            id="graduation_year"
            v-model="form.graduation_year"
            class="form-select">
            <option
              value="ALL"
              default
              class="text-center">
              ALL
            </option>
            <option
              v-for="option in graduationYearOptions"
              :key="option"
              :value="option">
              {{ option }}
            </option>
          </select>
        </div>
        <Link
          class="md:mt-7 btn-indigo"
          :href="route('eos_candidate.index')"
          as="button">
          <i class="fas fa-plus-square" /> Create Akhir Studi
        </Link>
        <button class="md:mt-7 md:ml-auto btn-green" @click.prevent="exportXls">
          <i class="fas fa-file-excel" /> Export Excel
        </button>
      </div>
    </div>
    <div class="overflow-x-scroll bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4 text-left">
              Nama Mahasiswa / NIM
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Kampus
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Kota Studi
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Tahun Masuk Kuliah
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Semester
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Jenjang Pendidikan
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Akhir Studi AKTIF
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Persetujuan Pembayaran
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Status Pembayaran
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Tanggal Verifikasi
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Tanggal Input
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in eosRecords.data"
            :key="row.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.mahasiswa.name }}<br><small>{{
                  row.mahasiswa.nim
                }}</small>
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.universitas.name }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.universitas.kota_studi }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.mahasiswa.college_entry_year }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.mahasiswa.current_semester }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.mahasiswa.jenjang_pendidikan }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.is_active ? "YA" : "TIDAK" }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.approval_status }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.payment_status }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.eos_verified_at }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos.edit', row.id)">
                {{ row.trn_date }}
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="eosRecords.links" />
  </div>
</template>

<script lang="js">
import Layout from '@/Shared/Layout'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import { Link, router } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'Verifikasi Akhir Studi '},

  components: {
    Pagination,
    flatPickr,
    SearchFilter,
    Link,
  },

  props: {
    filters: Object,
    eosRecords: Object,
    approvalStatusOptions: Array,
    paymentStatusOptions: Array,
    graduationYearOptions: Array,
  },

  layout: Layout,

  data () {
    return {
      form: {
        search: this.filters.search,
        trn_date: this.filters.trn_date,
        validation_doc_verified: this.filters.validation_doc_verified,
        diploma_verified: this.filters.diploma_verified,
        approval_status: this.filters.approval_status,
        payment_status: this.filters.payment_status,
        graduation_year: this.filters.graduation_year,
       },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        router.get(this.route('eos.index'), pickBy(this.form), {
          preserveState: true,
        })
      }, 150),
    },
  },

  methods: {
    reset () {
      this.form = mapValues(this.form, () => null)
      this.form.graduation_year = this.filters.graduation_year
    },
    exportXls () {
      window.open(this.route('eos.index', {
        ...pickBy(this.form),
        export: 1,
      }), '_blank')
    },
  },
}
</script>
